import { render, staticRenderFns } from "./SideTagSreplenish.vue?vue&type=template&id=80a1e0ae&scoped=true&"
import script from "./SideTagSreplenish.vue?vue&type=script&lang=js&"
export * from "./SideTagSreplenish.vue?vue&type=script&lang=js&"
import style0 from "./SideTagSreplenish.vue?vue&type=style&index=0&id=80a1e0ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a1e0ae",
  null
  
)

export default component.exports